import { css } from '@emotion/css';
import styled from '@emotion/styled';

import { IconButton } from 'components/shared/Buttons';
import { layers, MEDIA_QUERY, Theme } from 'theme';

export const averagePriceSpacer = css`
  padding-bottom: 135px;

  @media ${MEDIA_QUERY.MAX_XL} {
    padding-bottom: 140px;
  }

  @media ${MEDIA_QUERY.MAX_MD} {
    padding-bottom: 124px;
  }
`;

export const DisclaimerContent = styled.div`
  display: flex;
  flex-basis: 100%;
  background: #1e1e1e;
  height: 30px;
  font-weight: bold;
  align-items: center;
  font-size: 10px;
  color: #8e8d8d;

  @media ${MEDIA_QUERY.XL} {
    padding: 0 32px;
  }

  @media ${MEDIA_QUERY.MAX_XL} {
    padding: 15px 15px;
  }

  @media ${MEDIA_QUERY.MAX_MD} {
    display: none;
  }
`;

export const DisclaimerContentMobile = styled.div`
  display: none;
  background: #1e1e1e;
  font-weight: bold;
  font-size: 10px;
  color: #8e8d8d;
  position: sticky;
  top: 0;
  padding: 15px 15px;
  z-index: ${layers.disclaimer};
  @media ${MEDIA_QUERY.MAX_MD} {
    display: flex;
  }
`;

export const ConvertersHeaderWrapper = styled.div`
  header {
    @media ${MEDIA_QUERY.MAX_MD} {
      height: 100%;
      margin-top: 10px;
      padding-bottom: 10px;
    }

    & > div:first-of-type {
      flex-wrap: wrap;
      height: 100%;
      align-items: center;

      @media ${MEDIA_QUERY.MAX_SM} {
        justify-content: flex-end;
        gap: 0 8px;
      }

      > span {
        @media ${MEDIA_QUERY.MAX_SM} {
          flex-basis: 50%;
          text-align: right;

          & > span {
            margin-right: 15px;
          }
        }
      }

      > h3,
      span,
      button {
        order: 1;

        > span {
          margin-right: 0;
        }
      }

      > h3 {
        @media ${MEDIA_QUERY.MAX_SM} {
          flex-basis: 30%;
          padding: 5px 15px 5px;
        }
      }

      > button {
        @media ${MEDIA_QUERY.MAX_MD} {
          margin: 10px 0 0 0;
        }
      }

      > div {
        order: 0;
      }
    }
  }
`;

export const TableHeaderPriceInfo = styled.small`
  display: block;
  font-weight: normal;

  span {
    display: inline-block;

    &:first-letter {
      font-weight: bold;
    }

    &:last-child {
      margin-left: 5px;
    }
  }
`;

export const AddToCartButton = styled(IconButton)<{ theme?: Theme }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.mineShaftLightest};

  :disabled {
    span {
      background-color: ${({ theme }) => theme.colors.alphaGray};
      opacity: 0.5;
    }

    span:hover {
      background-color: ${({ theme }) => theme.colors.alphaGray};
    }
  }

  span {
    background-color: ${({ theme }) => theme.colors.alphaGray};

    :hover {
      background-color: ${({ theme }) => theme.colors.white};
    }
  }
`;
